import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Auth.css';

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    email: '', password: '', first_name: '', last_name: '', company: '', phone: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const set = field => e => setForm(f => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    if (form.password.length < 8) {
      setError('Le mot de passe doit contenir au moins 8 caractères.');
      return;
    }
    setLoading(true);
    try {
      await register(form);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Erreur lors de la création du compte.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-topbar">
        <Link to="/" className="auth-brand">🛡️ EvBackupManager</Link>
        <Link to="/login">Déjà inscrit ? Connexion →</Link>
      </div>
      <div className="auth-wrapper">
        <div className="auth-card">
          <h1>Créer un compte</h1>
          <p className="subtitle">Gratuit, sans carte bancaire</p>

          {error && <div className="alert alert-error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Prénom *</label>
                <input className="form-control" type="text" placeholder="Jean" value={form.first_name} onChange={set('first_name')} required />
              </div>
              <div className="form-group">
                <label>Nom *</label>
                <input className="form-control" type="text" placeholder="Dupont" value={form.last_name} onChange={set('last_name')} required />
              </div>
            </div>

            <div className="form-group">
              <label>Adresse email *</label>
              <input className="form-control" type="email" placeholder="vous@exemple.fr" value={form.email} onChange={set('email')} required />
            </div>

            <div className="form-group">
              <label>Mot de passe * <span style={{ color: 'var(--text-muted)', fontWeight: 400 }}>(8 caractères min.)</span></label>
              <input className="form-control" type="password" placeholder="••••••••" value={form.password} onChange={set('password')} required />
            </div>

            <div className="form-group">
              <label>Société <span style={{ color: 'var(--text-muted)', fontWeight: 400 }}>(optionnel)</span></label>
              <input className="form-control" type="text" placeholder="Ma Boutique SARL" value={form.company} onChange={set('company')} />
            </div>

            <div className="form-group">
              <label>Téléphone <span style={{ color: 'var(--text-muted)', fontWeight: 400 }}>(optionnel)</span></label>
              <input className="form-control" type="tel" placeholder="06 00 00 00 00" value={form.phone} onChange={set('phone')} />
            </div>

            <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
              {loading ? <><span className="spinner" /> Création…</> : 'Créer mon compte'}
            </button>
          </form>

          <div className="auth-footer">
            Déjà inscrit ? <Link to="/login">Se connecter</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
